// 查询 daemon 会话信息；staleTime 60s 避免每次路由切换重拉。
// enabled 给根组件用：在 /login 页不应再 fetch 自身。
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/api/client";
import { API_SESSION } from "@/api/endpoints";
import type { SessionInfo } from "@/api/types";

export function useSession(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["session"],
    queryFn: () => apiGet<SessionInfo>(API_SESSION),
    staleTime: 60_000,
    retry: false,
    enabled: options.enabled ?? true,
  });
}
